import * as XLSX from 'xlsx';
import { parseCsvText } from './parseCsv';
import { ImportParseResult } from './types';

export async function parseExcelFile(file: File): Promise<ImportParseResult> {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: 'array' });
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) {
    return { rows: [], source: 'excel', warnings: ['Excel file has no sheets.'] };
  }
  const sheet = workbook.Sheets[sheetName];
  const csv = XLSX.utils.sheet_to_csv(sheet);
  const parsed = parseCsvText(csv);
  return { ...parsed, source: 'excel' };
}
